import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../connections/AuthContext';
import routes_web from '../../connections/routes_web';

import NavbarTop from './moduleComponents/NavbarTop';
import ViewBackHeader, { useReturnToPrevious } from './moduleComponents/ViewBackHeader';

const UserSettingsMain = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const goBack = useReturnToPrevious();

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center p-4">
      <div className="max-w-5xl w-full mx-auto pt-14">
        <NavbarTop
          title="Ecosystem"
          onHomeClick={() => navigate(routes_web.accounts_home)}
        />

        <div>
          <ViewBackHeader title="User Profile" onBack={goBack} />

          <div className="bg-white rounded-lg shadow p-6">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">User Information</h2>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-600">Username</label>
                <p className="mt-1 text-gray-800">{user?.username}</p>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600">Email</label>
                <p className="mt-1 text-gray-800">{user?.email || 'Not set'}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserSettingsMain;
